import { omitEmpty, type AnalyticsProps } from "./props";

export type AnalyticsActor = "payer" | "visitor" | "user" | "merchant";

let sessionContext: AnalyticsProps = {};

/** Persist org/user traits onto every later event (cleared on reset). */
export function setAnalyticsSession(ctx: AnalyticsProps) {
  sessionContext = { ...sessionContext, ...omitEmpty(ctx) };
}

export function clearAnalyticsSession() {
  sessionContext = {};
}

export function getAnalyticsSession(): AnalyticsProps {
  return { ...sessionContext };
}

export function detectDevice(): "mobile" | "tablet" | "desktop" {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  if (/iPad|Tablet/i.test(ua)) return "tablet";
  if (/Mobi|Android/i.test(ua)) return "mobile";
  return "desktop";
}

export function enrichEventProps(
  event: string,
  properties: AnalyticsProps | undefined,
  defaults: {
    actor: AnalyticsActor;
    surface: string;
    taxonomyByEvent: Record<string, string>;
  }
): AnalyticsProps {
  const taxonomy_id =
    (properties?.taxonomy_id as string | undefined) ||
    defaults.taxonomyByEvent[event];

  return omitEmpty({
    actor: defaults.actor,
    surface: defaults.surface,
    device: detectDevice(),
    ...getAnalyticsSession(),
    ...(taxonomy_id ? { taxonomy_id } : {}),
    ...properties,
  });
}
